module.exports = __webpack_public_path__ + "img/FPT13.01c60646.svg";